import { render, staticRenderFns } from "./NoteButtons.vue?vue&type=template&id=58f7c88c"
import script from "./NoteButtons.vue?vue&type=script&lang=js"
export * from "./NoteButtons.vue?vue&type=script&lang=js"
import style0 from "./NoteButtons.vue?vue&type=style&index=0&id=58f7c88c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports